import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FluidContainer from '../../layouts/components/fluid-container';
import Skeleton from '../../skeleton';
import Spacer from '../../spacer';
import { Heading, Helper } from '../../typography';
import { getPerformerBoxColor, getPerformerColor } from '../../../lib/utils';

const Phase = styled.div`
    border-radius: 8px;
    padding: 8px;
    width: fit-content;
    background-color: ${(props) => props.color};
    text-transform: ${(props) => props.isUpperCase && 'uppercase'};
`;

const Titles = styled.ul`
    margin: 0;
    padding-left: 22px;
    list-style-position: outside;
`;

const skeletonItems = [
    { width: 40 },
    { width: 0, height: 'small' },
    { width: 100 },
    { width: 100 },
    { width: 60 },
    { width: 0 },
    { width: 40, height: 'regular' },
    { width: 100, height: 'regular' },
];

const StyledHeading = styled(Heading)`
    color: ${({ textColor }) => textColor || 'var(--gray800)'};
`;

const PerformerStartPage = ({ exercisesTitle, courseId, homeworkChapter, isLoading, journey, phase, publicTitle }) => {
    return (
        <FluidContainer flexDirection="column" maxWidth={['100%']} paddingTop={[70, 70, 140]}>
            <Skeleton isLoading={isLoading} items={skeletonItems}>
                {'Questo è il percorso'}
                <Spacer size="small" />
                {courseId !== '2000273319' ? (
                    <Phase color={getPerformerBoxColor(phase)}>
                        <StyledHeading level={3} weight="semi-bold" textColor={getPerformerColor(phase)}>
                            {phase}
                        </StyledHeading>
                    </Phase>
                ) : (
                    <StyledHeading level={3} weight="semi-bold" textColor={getPerformerColor(phase)} style={{ textTransform: 'uppercase' }}>
                        {phase}
                    </StyledHeading>
                )}

                <Spacer size="small" />

                <Heading level={3} weight="semi-bold">
                    {courseId !== '2000273319' ? `${homeworkChapter} – ${journey}` : `${homeworkChapter}`}
                </Heading>
                {courseId !== '2000273319' ? (
                    <Heading level={3} weight="semi-bold">
                        {publicTitle}
                    </Heading>
                ) : (
                    <Phase color={getPerformerBoxColor(phase)} isUpperCase={false}>
                        <Heading level={3} weight="semi-bold">
                            {publicTitle}
                        </Heading>
                    </Phase>
                )}

                <Spacer size="medium" />
                {exercisesTitle?.length > 0 && (
                    <>
                        {`Il percorso è costituito da:`}
                        <Titles>
                            {exercisesTitle.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </Titles>
                    </>
                )}

                <Spacer size="medium" />
                <Heading level={2} weight="light">
                    {'Iniziamo?'}
                </Heading>
                <Spacer size="small" />
                <Helper weight="semi-bold">{'Usa il pulsante "Inizia"'}</Helper>
            </Skeleton>
        </FluidContainer>
    );
};

PerformerStartPage.propTypes = {
    exercisesTitle: PropTypes.array,
    homeworkChapter: PropTypes.string,
    courseId: PropTypes.string,
    isLoading: PropTypes.bool,
    journey: PropTypes.string,
    phase: PropTypes.string,
    publicTitle: PropTypes.string,
};

export default PerformerStartPage;
